<template>
  <div class="wrapper">
    <!-- data Table -->
    <div v-if="showPage">
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="
                d-flex
                justify-content-between
                align-items-center
                bg-secondary
              "
            >
              <h5 class="text-light m-0 p-0">ثبت هزینه</h5>
              <CButton
                color="light"
                @click="
                  addCostServiceModal = true;
                  modalTitle = 'افزودن هزینه';
                  modalButtonSubmit = 'ثبت';
                  costInfo = [];
                  restoreDefault();
                  GetOrganizationalStructureTreePerUser();
                "
                class="mr-1"
              >
                <CIcon name="cil-plus" /> افزودن
              </CButton>
            </CCardHeader>
            <CCardBody class="m-0 p-0">
              <CCard>
                <CButton
                  block
                  class="text-right shadow-none bg-warning card-header"
                  @click="showFilter = showFilter === 6 ? false : 6"
                >
                  <h5 class="text-primary"><CIcon :name="showFilter==0 ? 'cil-chevron-bottom' : 'cil-chevron-top'" /> فیلتر</h5>
                </CButton>
                <CCollapse :show="showFilter === 6">
                  <CCardBody>
                    <CRow>
                      <v-jstree
                        class="my-2"
                        :data="structureListFillter"
                        show-checkbox
                        allow-batch
                        whole-row
                        noDots
                        allow-empty
                        @item-click="setFillter"
                      ></v-jstree>
                    </CRow>
                    <!-- <CRow>
                      <CButton
                        @click="getAlarms()"
                        class="
                          mt-4
                          mb-3
                          btn-success
                          col-12
                        "
                        ><CIcon
                          name="cil-check-circle"
                          class="text-light align-self-center"
                      /></CButton>
                    </CRow> -->
                  </CCardBody>
                </CCollapse>
              </CCard>
              <div id="userapp">
                <!-- <link
                  href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                  rel="stylesheet"
                  integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
                  crossorigin="anonymous"
                /> -->
                <main>
                  <data-table
                    v-bind="parametersTable"
                    @actionTriggered="handleAction"
                  />
                </main>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>

    <!-- create and edit costService modal -->
    <CModal :title="modalTitle" :show.sync="addCostServiceModal" size="xl"  :close-on-backdrop="false">
      <CForm class="needs-validation" novalidate>
        <CAlert color="warning" closeButton :show.sync="alert">
          {{ alertText }}
        </CAlert>
        <h5 class="text-primary mb-3">اطلاعات هزینه</h5>
        <hr />

        <v-jstree
          :data="structureList"
          show-checkbox
          allow-batch
          whole-row
          noDots
          @item-click="itemClick"
        ></v-jstree>

        <CRow>
          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">دستگاه</label>
            <multiselect
              class="needs-validation"
              v-model="costInfo.device"
              :options="deviceList"
              :allow-empty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              required
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <div role="group" class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label for="uid-vvb5dt2i0jd" class="">تاریخ </label>
            <date-picker
              placeholder="تاریخ"
              class="col-sm-12 col-md-6 col-lg-3 mt-1"
              v-model="costInfo.date"
              :value="costInfo.date"
              :autoSubmit="true"
              required
            ></date-picker>
          </div>

          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="مورد هزینه"
            v-model="costInfo.name"
            required
            :value="costInfo.name"
          />

          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="مبلغ (ریال)"
            v-model="costInfo.cost"
            required
            :value="costInfo.cost"
            type="number"
          />
        </CRow>

        <CTextarea
          label="توضیحات"
          placeholder="Content..."
          rows="5"
          v-model="costInfo.description"
          :value="costInfo.description"
        />
      </CForm>

      <template #footer>
        <CButton
          v-if="modalButtonSubmit == 'تایید'"
          @click="addCostServiceModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />تایید</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="addCostServiceModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template>
    </CModal>

    <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف هزینه'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف هزینه'"
          @click="deleteCostService"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style lang="css">
.table-wrapper {
  height: 60vh !important;
}
.msl-search-list-input {
  direction: rtl;
}
</style>

<script>
import axios from "axios";
import { Values } from "../../commonValues";
import $ from "jquery";
import vMultiselectListbox from "vue-multiselect-listbox";
import Multiselect from "vue-multiselect";

import VJstree from "vue-jstree-master"; //rtl
// import VJstree from "vue-jstree";  //ltrl

export default {
  name: "Modals",

  components: {
    vMultiselectListbox,
    VJstree,
    Multiselect,
  },

  data() {
    return {
      fillterActive: false,
      structureListFillter: [],
      showFilter: 0,
      disableMultiselect: false,

      addCostServiceModal: false,
      costServices: [],
      costServicesFilltered: [],

      modalTitle: "",
      modalButtonSubmit: "",

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      costId: "",

      costInfo: {
        id: "",
        name: "",
        description: "",
        cost: "",
        date: "",
        device: {
          value: "",
          label: "گیرنده اول",
        },
      },

      deviceList: [
        // { label: "هلال", value: 1 },
        // { label: "ناوگان 2", value: 2 },
        // { label: "ای سی اچ", value: 0 },
      ],

      alert: false,
      alertText: "",

      permissionList: [],
      selectedPermissionList: [],
      pathAuthorizationIds: [1, 2, 4],

      showPage: true,

      structureList: [],
    };
  },

  computed: {
    parametersTable() {
      return {
        data: this.fillterActive==false ?this.costServices : this.costServicesFilltered,
        actionMode: "single",
        columns: [
          {
            key: "rowNumber",
            title: "ردیف",
          },
          {
            key: "deviceName",
            title: "دستگاه",
          },
          {
            key: "forWhat",
            title: "هزینه",
          },
          {
            key: "amount",
            title: "مبلغ",
          },
          {
            key: "date",
            title: "تاریخ",
          },
        ],
        actions: ["view", "edit", "delete"],
      };
    },
  },

  mounted() {
    this.refreshTable();
    //this.getdeviceList();
    this.GetOrganizationalStructureTreePerUser();
  },

  methods: {
    //********************************************************************* get organiztion tree  per user*/
    GetOrganizationalStructureTreePerUser() {
      axios
        .get(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTreeForUser"
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.structureList = response.data;
            this.structureListFillter = response.data;
            this.deviceList = [];
            this.GetUserDeviceAccessPermission(false);
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //****************************************************************** select parrent */
    itemClick(node) {
      this.selectedParent = node.model.id;

      this.costInfo.device = {
        value: "",
        label: "",
      };
      this.GetDeviceLevelSelectListForUser(node.model.id);
    },

    //********************************************************************* get organiztion tree  per user*/
    GetUserDeviceAccessPermission(data, whichView, actionData) {
      axios
        .get(Values.serverIp + "User/GetUserDeviceAccessPermission")
        .then((response) => {
          if (response.status == 200) {
            // console.log(response.data);
            if (data == false) {
              if (response.data.organizationId != 0) {
                this.GetDeviceLevelSelectListForUser(
                  response.data.organizationId
                );
              }
            } else {
              this.GetDeviceLevelSelectListForUser(
                response.data.organizationId,
                whichView,
                actionData
              );
            }

            //this.structureList = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* get device per user*/
    GetDeviceLevelSelectListForUser(data, whichView, actionData) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "UserDeviceAccessPermission/GetDeviceLevelSelectListForUser",
          JSON.stringify(data),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.deviceList = response.data;
            if (whichView == "view") this.viewAction(actionData);
            else if (whichView == "edit") this.editAction(actionData);
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "2خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* get device list */
    getdeviceList() {
      axios
        .get(Values.serverIp + "device/GetDualBoxMovingDeviceList")
        .then((response) => {
          //console.log(response.data);
          this.deviceList = response.data;
        });
    },

    //********************************************************************* refresh datatable */
    refreshTable() {
      axios
        .get(Values.serverIp + "Cost/Costs")
        .then((response) => {
          // console.log(response.data.data);
          this.costServices = response.data.data;
        })
        .catch((response) => {
          //console.log(response.response);
          //console.log("in catch");
          if (response.response.status == 403) {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else if (response.response.status == 401) {
            //token has expired
            // modal unsuccessful edit change
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            delete axios.defaults.headers.common["Authorization"];
          }
        });
    },

    //********************************************************************* datatable view action */
    viewAction(data) {
      // disable alet
      this.alert = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Cost/GetCost",
          JSON.stringify(data.costId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.addCostServiceModal = true;
            this.modalTitle = "ویرایش هزینه";
            this.modalButtonSubmit = "تایید";

            // clear all red borders
            $(".form-control").removeAttr("style");

            // clear all red borders
            $(
              ".form-control, .needs-validation > .multiselect__tags"
            ).removeAttr("style");

            // costId: this.costInfo.id,
            // forWhat: this.costInfo.name,
            // description: this.costInfo.description,
            // amount: this.costInfo.cost,
            // jalaliDate: this.costInfo.date,
            // deviceId: this.costInfo.device.id,

            (this.costInfo.id = response.data.costId),
              (this.costInfo.name = response.data.forWhat),
              (this.costInfo.description = response.data.description);
            this.costInfo.date = response.data.jalaliDate;
            this.costInfo.cost = response.data.amount;
            this.setDeviceValue(response.data.deviceId);

            // make all part to disabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              true
            );
            this.disableMultiselect = true;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              //(this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable edit action */
    editAction(data) {
      // disable alet
      this.alert = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Cost/GetCost",
          JSON.stringify(data.costId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.addCostServiceModal = true;
            this.modalTitle = "ویرایش هزینه";
            this.modalButtonSubmit = "اعمال";

            // clear all red borders
            $(".form-control").removeAttr("style");

            // make all part to enabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              false
            );

            // clear all red borders
            $(
              ".form-control, .needs-validation > .multiselect__tags"
            ).removeAttr("style");

            this.disableMultiselect = false;

            this.costInfo.id = response.data.costId;
            this.costInfo.name = response.data.forWhat;
            this.costInfo.description = response.data.description;
            this.costInfo.date = response.data.jalaliDate;
            this.costInfo.cost = response.data.amount;
            this.setDeviceValue(response.data.deviceId);
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              //(this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable delete action */
    deleteAction(data) {
      (this.alertModal = true),
        (this.alertModalTitle = "حذف هزینه"),
        (this.alertModalText =
          "آیا از حذف هزینه " + data.name + " مطمئن هستید؟"),
        (this.alertModalColor = "warning"),
        (this.alertModalButtonText = "بله"),
        (this.costId = data.costId);
    },

    //********************************************************************* dataTable actions */
    handleAction(actionName, data) {
      if (actionName == "view") {
        this.GetOrganizationalStructureTreePerUser();
        this.GetUserDeviceAccessPermission(true, "view", data);
      } else if (actionName == "edit") {
        //this.editAction(data);
        this.GetOrganizationalStructureTreePerUser();
        this.GetUserDeviceAccessPermission(true, "edit", data);
      } else if (actionName == "delete") {
        this.deleteAction(data);
      }
    },

    //********************************************************************* edit and create costService */
    submitForm() {
      // clear all red borders
        $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
          "style"
        );

      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control").removeAttr("style");
      
      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;

      console.log(forms);

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].placeholder == "تاریخ" &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (this.costInfo.device.value == "") {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }
      }

      let api = "";
      if (this.modalButtonSubmit == "اعمال") api = "EditCost";
      else {
        api = "CreateCost";
        this.costInfo.id = "";
      }

      if (formValid == true) {
        //console.log(this.userInfo.active);
        axios
          .post(Values.serverIp + "Cost/" + api, {
            costId: this.costInfo.id,
            forWhat: this.costInfo.name,
            description: this.costInfo.description,
            amount: this.costInfo.cost,
            jalaliDate: this.costInfo.date,
            deviceId: this.costInfo.device.value.split(",")[1],
          })
          .then((response) => {
            console.log(response);
            if (response.status == 200) {
              this.addCostServiceModal = false;

              // modal successfuly
              this.alertModal = true;
              this.alertModalTitle = "تغییرات";
              this.alertModalText = "تغییرات با موفقیت انجام شد.";
              this.alertModalColor = "success";
              this.alertModalButtonText = "تایید";
              this.refreshTable();
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "نام هزینه یا اطلاعات وارد شده درست نمی باشد.";
              this.alertModalColor = "warning";
              this.alertModalButtonText = "تایید";
            }
          })
          .catch((response) => {
            if (response.response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                //(this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
          });
      } else {
        // this.alert = true;
        // this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";
        (this.alertModal = true),
              (this.alertModalTitle = "هشدار"),
              (this.alertModalText =
                "لطفا تمامی موارد الزامی را وارد نمایید."),
              (this.alertModalColor = "warning"),
              (this.alertModalButtonText = "تایید");
      }
    },

    //********************************************************************* delete user */
    deleteCostService() {
      this.alertModal = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Cost/DeleteCost",
          JSON.stringify(this.costId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            (this.alertModal = true),
              (this.alertModalTitle = "حذف"),
              (this.alertModalText = "حذف هزینه با موفقیت انجام شد"),
              (this.alertModalColor = "success"),
              (this.alertModalButtonText = "تایید"),
              this.refreshTable();
          } else {
            //console.log("in else"),
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              //(this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //******************************************************************** make form to default mode */
    restoreDefault() {
      this.disableMultiselect = false;

      (this.costInfo = {
        id: "",
        name: "",
        description: "",
        cost: "",
        data: "",
        device: {
          value: "",
          label: "",
        },
      }),
        // clear all red borders
        $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
          "style"
        );

      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control").removeAttr("style");

      // disable alet
      this.alert = false;
    },

    //********************************************************************* on edit acttion set device status */
    setDeviceValue(data) {
      for (var i = 0; i < this.deviceList.length; i++) {
        if (this.deviceList[i].value.split(",")[1] == data) {
          this.costInfo.device.label = this.deviceList[i].label;
          this.costInfo.device.value = this.deviceList[i].value;
        }
      }
    },

    //***************************************************************** */
    setFillter(node) {
      // this.selectedParent = node.model.id;
      // console.log(this.selectedParent);

      this.costServicesFilltered = this.costServices.filter(function (el) {
        return el.organizationIdTree.includes(node.model.id);
        //el.statusId.includes(tempIds)
      });

this.fillterActive=true;
      //console.log(this.costServicesFilltered);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css">
